export const insights_english = {
  "Häufige Abkürzungen": "Common abbreviations",
  "Zentrale Begriffe": "Key terms",
};
